__turbopack_context__.v({
  "className": "TLBodq_className",
  "variable": "TLBodq_variable",
});
